import { FortimeOrderWithItems, OrderReviewSB } from "./types";
import {
  convertCreateOrderToFortime,
  convertFortimeOrderToBaseOrder,
  convertOrderReviewSB,
  convertSBOrderReview,
} from "./converters";
import {
  CreateOrderData,
  CreatePaymentPayload,
  BaseOrdersClient,
  OrderReviewType,
  PaymentFormData,
  ORDERS_PARAMS,
  TOrder,
  OrderHistory,
  ORDERS_HISTORY_PARAMS,
  OrderTrackingPayload,
  OrderTracking,
} from "@core/types";

class OrdersClient extends BaseOrdersClient {
  async getOrdersHistory(params: ORDERS_HISTORY_PARAMS): Promise<OrderHistory[]> {
    throw new Error("getOrdersHistory not implemented");
  }

  async getUnpaidOrdersId(): Promise<TOrder["id"][]> {
    throw new Error("getUnpaidOrdersId not implemented");
  }

  async getOrders(params: ORDERS_PARAMS): Promise<TOrder[]> {
    const response = await this.instance.get<FortimeOrderWithItems[]>("wp-json/wc/v3/orders/", {
      params: { ...params },
    });

    return response.data.map(convertFortimeOrderToBaseOrder);
  }
  async getOrderById(id: string): Promise<TOrder> {
    const response = await this.instance.get<FortimeOrderWithItems>(`/wp-json/wc/v3/orders/${id}`);

    return convertFortimeOrderToBaseOrder(response.data);
  }

  async createOrder(orderData: CreateOrderData): Promise<TOrder> {
    const order4time = convertCreateOrderToFortime(orderData);

    const { data } = await this.instance.post<FortimeOrderWithItems>("wp-json/parhato-api/v1/orders", order4time);

    return data && convertFortimeOrderToBaseOrder(data as FortimeOrderWithItems);
  }

  async createPayment(payload: CreatePaymentPayload): Promise<PaymentFormData> {
    throw new Error("createPayment not implemented");
  }

  async getReviewSetOrderById(orderId: string): Promise<OrderReviewType | null> {
    const { data: orderReview } = await this.instance.get<OrderReviewSB>(`/wp-json/wc/v3/orders/reviews`, {
      params: {
        orderId,
      },
    });

    return orderReview && convertSBOrderReview(orderReview);
  }

  async addReviewOrder(orderData: OrderReviewType): Promise<OrderReviewType | null> {
    const orderReview = convertOrderReviewSB(orderData);

    const { data } = await this.instance.post<OrderReviewSB>(`/wp-json/wc/v3/orders/reviews/add`, orderReview);

    return data && convertSBOrderReview(data);
  }
    async getOrderTracking(orderReqData: OrderTrackingPayload): Promise<OrderTracking | null> {
      throw new Error("getOrderTracking is not implemented");
    }

    async orderCancel(orderId: string): Promise<TOrder> {
      throw new Error("orderCancel is not implemented");
    }
    async createTaxiOrder(orderId: TOrder["id"]): Promise<any> {
      throw new Error("createTaxiOrder is not implemented");
    }
}

export default OrdersClient;
